import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentRequirementsCtrl implements IController {

  agent: AgentModel;
  score: any;

  onAssign: Function;

  private loading: boolean;
  private requirements: any;
  private selectedRequirement: any;

  constructor(private agentRequests: AgentRequests, private $log, private agentsAlerts: AgentsAlerts,
              private $stateParams, private $state) {
  }

  $onInit() {
    this.requirements = [];
    this.reloadRequirements();
  }

  selectRequirement(requirement) {
    if (requirement) {
      this.$state.go('.', {requirementId: requirement.id}, {notify: false});
    }
    this.reloadRequirements();
  }

  requirementChanged(updatedRequirement) {

    const updatedRequirementIndex =  _.findIndex(this.requirements,(requirement: any) => {
      return _.isEqual(requirement.id, updatedRequirement.id); }
    );

    if (!_.isEqual(updatedRequirementIndex, -1)) {
      this.requirements[updatedRequirementIndex] = updatedRequirement;
      this.agentsAlerts.updateRequirementSuccess();
    } else {
      this.agentsAlerts.updateRequirementError();
      this.$log.error('Updated Requirement Id did not match any agent\'s requirement ' +
        'agentRequirementsCtrl@requirementsUpdate \n')
    }
  }

  reloadRequirements() {
    this.loading = true;
    this.agentRequests.getRequirements(this.$stateParams.id)
      .then((allRequirements) => {
        this.requirements = allRequirements;
        if (allRequirements.length) {
          if (!this.$stateParams.requirementId) {
            this.$state.go('.', {requirementId: allRequirements[0].id}, {notify: false});
            this.selectedRequirement = allRequirements[0];
          }else {
            _.forEach(allRequirements,(requirement) => {
              if (_.isEqual(requirement.id, this.$stateParams.requirementId)) {
                this.selectedRequirement = requirement;
                return true;
              }
            });
          }
        }
      })
      .catch((error) => {
        this.$log.error('Failed to get requirements from server, ' +
          'AgentsAbstractState@triangular.agent.agent-profile.requirements \n' + error)
      })
      .finally(() => {
        this.loading = false;

      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRequirements', {
    bindings: {
      agent: '<',
      selectedVehicle: '<'
    },
    template: require('./agent-requirements.html').default,
    controller: AgentRequirementsCtrl
  });
